<!--
 * @Date: 2023-04-17 17:25:57
 * @LastEditors: limeng1
 * @LastEditTime: 2023-04-25 19:58:47
 * @Description:
-->
<script
  lang="ts"
  setup
>
import {
  computed,
  defineAsyncComponent,
  ref,
  watch,
} from '#imports'
import { type ActivityIconTypeUS } from '~/api'
import { useLayout } from '~/store/layout'
import $track from '~/track/webOfficialWebsite'

const AsyncScrollLoadingAnimation = defineAsyncComponent(() => import('~/components/LottieAnimation.vue'))
const lottieData = async () => (await import('@/assets/images/activity/activity-enter-us.json')).default
defineProps<{
  activity: ActivityIconTypeUS
}>()
const isMobile = computed(() => useLayout().isMobile)
const visible = ref<boolean>(false)
const activeIndex = ref<number>(0)
// 展开活动
const onClick = () => {
  visible.value = true
  $track.web_official_activity_banner_click({ template: 'US' })
}
const onClose = () => {
  visible.value = false
  activeIndex.value = 0
  $track.web_official_activity_pop_click({ template: 'US', item: 'close', pop_rank: 0 })
}
// 点击banner
const onGroupClick = (url: string, index: number) => {
  window.open(url, '_blank')
  $track.web_official_activity_pop_click({ template: 'US', item: index, pop_rank: 0 })
}

watch(visible, (val: boolean) => {
  if (val) {
    $track.web_official_activity_pop_show({ template: 'US', pop_rank: 0 })
  }
})

</script>

<template>
  <div
    v-if="isMobile && visible"
    class="mask"
  />
  <AsyncScrollLoadingAnimation
    v-if="!visible && activity?.list?.length"
    :animation-data="lottieData"
    :class="isMobile ? 'mobile-activity-animation' : 'activity-animation'"
    autoplay
    @click="onClick"
  />
  <Transition :name="isMobile ? 'fade-in-bottom' : 'slide-fade'">
    <div
      v-if="visible"
      :class="['activity', isMobile ? 'mobile-activity' : '']"
    >
      <div
        class="close"
        @click="onClose"
      >
        <img
          v-if="isMobile"
          alt=""
          src="@/assets/images/activity/icon-close.svg"
        >
        <img
          v-else
          alt=""
          src="@/assets/images/activity/icon-unfold.svg"
        >
      </div>
      <div class="activity__banner">
        <img
          :src="activity?.banner?.image"
          alt=""
        >
      </div>
      <div class="groups">
        <div
          v-for="(item, index) in activity?.list"
          :key="item.deepLink"
          :style="{ background: item.color, '--hover-color': item.hover_color || item.color }"
          class="group-item"
          @click="onGroupClick(item.deepLink!, index)"
        >
          <div class="group-item__icon">
            <img
              :src="item.image"
              alt=""
            >
          </div>
          <span>{{ item.desc }}</span>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style
  lang="less"
  scoped
>
.activity-animation {
  position: fixed;
  z-index: 9999;
  right: 46px;
  bottom: 46px;
  width: 110px;
  cursor: pointer;
}

.mobile-activity-animation {
  position: fixed;
  z-index: 998;
  right: 20px;
  bottom: 20px;
  width: 84px;
}

/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-in-bottom-enter-active {
  transition: all 0.5s ease-out;
}

.fade-in-bottom-leave-active {
  transition: all 0.5s ease-out;
}

.fade-in-bottom-enter-from,
.fade-in-bottom-leave-to {
  //transform: translate(20px,160px);
  opacity: 0;
}

img {
  width: 100%;
  height: 100%;
}

.activity {
  position: fixed;
  z-index: 9999;
  right: 46px;
  border-radius: 16px;
  overflow: hidden;
  bottom: 46px;
  width: 388px;
  /* background-color: #fff; */
  filter: drop-shadow(0px 4px 24px rgba(134, 163, 184, 0.32));

  &__banner {
    width: 100%;
    background-color: #fff;
  }

  .groups {
    padding: 24px 16px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 0 0 16px 16px;

    .group-item {
      display: flex;
      border-radius: 8px;
      align-items: center;
      cursor: pointer;

      padding: 13px;

      span {
        font-size: 16px;
        line-height: 22px;
        color: #fff;
        margin-left: 16px;
      }

      &__icon {
        height: 24px;
        width: 24px;
        flex-shrink: 0;
      }

      &:hover {
        background-color: var(--hover-color) !important;
      }
    }
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 999;
    cursor: pointer;
  }

}

.mobile-activity {
  position: fixed;
  right: calc(50vw - 160px) !important;
  top: calc(50vh - 200px) !important;
  width: 320px;
  bottom: auto;
}

:deep(.el-carousel__arrow) {
  background-color: rgba(0, 0, 0, 0.2);
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 9998;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
}
</style>
